// Registers the shell package's `shell` i18n namespace (tour popover chrome and
// the tour demo mock UIs) on the app's i18next instance, at bootstrap, the way
// a feature package gets its namespace registered by its host. configs/i18n is
// imported first so the instance is initialised before the bundles are added.
import i18n from '@/configs/i18n'
import { registerShellLocales } from '@vnetwork/datacentral-shell/locales'

registerShellLocales(i18n)
